/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlModification } from './ControlModification';
import {
    ControlModificationFromJSON,
    ControlModificationFromJSONTyped,
    ControlModificationToJSON,
    ControlModificationToJSONTyped,
} from './ControlModification';

/**
 * 
 * @export
 * @interface ProfileUpdateRequest
 */
export interface ProfileUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateRequest
     */
    oscalVersion?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileUpdateRequest
     */
    selectedControlIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileUpdateRequest
     */
    excludedControlIds?: Array<string>;
    /**
     * 
     * @type {Array<ControlModification>}
     * @memberof ProfileUpdateRequest
     */
    modifications?: Array<ControlModification>;
}

/**
 * Check if a given object implements the ProfileUpdateRequest interface.
 */
export function instanceOfProfileUpdateRequest(value: object): value is ProfileUpdateRequest {
    return true;
}

export function ProfileUpdateRequestFromJSON(json: any): ProfileUpdateRequest {
    return ProfileUpdateRequestFromJSONTyped(json, false);
}

export function ProfileUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'version': json['version'] == null ? undefined : json['version'],
        'description': json['description'] == null ? undefined : json['description'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'selectedControlIds': json['selectedControlIds'] == null ? undefined : json['selectedControlIds'],
        'excludedControlIds': json['excludedControlIds'] == null ? undefined : json['excludedControlIds'],
        'modifications': json['modifications'] == null ? undefined : ((json['modifications'] as Array<any>).map(ControlModificationFromJSON)),
    };
}

export function ProfileUpdateRequestToJSON(json: any): ProfileUpdateRequest {
    return ProfileUpdateRequestToJSONTyped(json, false);
}

export function ProfileUpdateRequestToJSONTyped(value?: ProfileUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'version': value['version'],
        'description': value['description'],
        'documentId': value['documentId'],
        'oscalVersion': value['oscalVersion'],
        'selectedControlIds': value['selectedControlIds'],
        'excludedControlIds': value['excludedControlIds'],
        'modifications': value['modifications'] == null ? undefined : ((value['modifications'] as Array<any>).map(ControlModificationToJSON)),
    };
}

